import { BillingMethod } from '../../../generated/graphql';

/**
 * Client-side mirror of the server validation. Returns an error message to show, or null
 * when the link is acceptable. The server re-validates and extracts the id authoritatively.
 */
export const validateBillingLink = (
  method: BillingMethod,
  link: string,
): string | null => {
  const trimmed = link.trim();

  if (method === BillingMethod.Stripe) {
    if (!/stripe\.com/.test(trimmed) || !/\/cus_[A-Za-z0-9]+/.test(trimmed)) {
      return 'Enter a Stripe customer link (must contain stripe.com and /cus_).';
    }
    return null;
  }

  if (!/fakturoid\.cz\/dishboard\/subjects\/\d+/.test(trimmed)) {
    return 'Enter a Fakturoid subject link (app.fakturoid.cz/dishboard/subjects/...).';
  }
  return null;
};
